<template>
  <!-- 内部用户管理 -->
  <div class="page-container" id="userManagementContainer">
    <el-form
      :model="userManagementForm"
      ref="ruleFormRef"
      class="form-panel"
      label-position="top"
      :validateOnRuleChange="false"
    >
      <el-col :span="24">
        <el-row class="content-panel top-radius" id="searchPanel">
          <el-col>
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item label="登录账号">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.userName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="中文名称">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.userNameCn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="英文名称">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.userNameEn"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="电子邮箱">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.email"
                  ></el-input>
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item label="手机号码">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.mobilePhone"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="是否有效">
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="userManagementForm.isActive"
                    placeholder="请选择"  clearable
                  >
                    <el-option
                      v-for="item in dict.MD_CODE_DICT$MD_CODE_YESNO"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户属性(内部/外部)">
                  <el-select
                    class="length_input"
                    size="mini"
                    v-model="userManagementForm.isExternal"
                    placeholder="请选择" clearable
                  >
                    <el-option
                      v-for="item in dict.MD_CODE_DICT$EB_USER_EXTERNAL"
                      :key="item.key"
                      :label="item.value"
                      :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="客户名称">
                  <el-associate style="width: 100%;"
                                :columns="associate_columns_csCustCm"
                                :query-method="associate_queryMethod_csCustCm"
                                class="input_length"
                                clearable
                                :query-length="0"
                                :default-first-option="true"
                                label-prop="custNameCn"
                                value-prop="csCustId"
                                placeholder=""
                                v-model="userManagementForm.custId"
                                size="mini"
                  />
                </el-form-item>
              </el-col>
            </el-row>
            <el-row :gutter="22">
              <el-col :span="6">
                <el-form-item label="间接客户公司">
                  <el-input
                    size="mini"
                    v-model="userManagementForm.companyName"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="用户来源" prop="userSource">
                  <el-select
                      class="length_input"
                      size="mini"
                      v-model="userManagementForm.userSource"
                      placeholder="请选择"
                  >
                    <el-option
                        v-for="item in dict.UserSource"
                        :key="item.key"
                        :label="item.value"
                        :value="item.key"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
              </el-col>
            </el-row>
          </el-col>
          <el-col>
            <el-button type="primary" size="small" plain @click="handleQuery"
            >查询
            </el-button
            >
            <el-button type="primary" size="small" plain @click="handleReset"
            >重置
            </el-button
            >
            <el-button type="primary" size="small" plain @click="handleAdd"
            >新增用户
            </el-button
            >
            <el-button type="danger" size="small" plain @click="handleDelete"
            >删除用户
            </el-button
            >
            <el-button type="primary" size="small" plain @click="handleEnable"
            >生效
            </el-button
            >
            <el-button type="danger" size="small" plain @click="handleDisable"
            >失效
            </el-button
            >
          </el-col>
        </el-row>
        <!-- 表格-start -->
        <el-row style="margin-top: 15px">
          <hot-table
            ref="userManagementTableRef"
            :data-source="userManagementTableDataSource"
            :settings="userManagementTableSettings"
            col-settings-key="userManagement"
            @rowDblclick='toInternalUserEditing'
          >
            <hot-column
              :has-tip="true"
              data="userName"
              title="登陆账号"
              width="150"
            >
            </hot-column>

            <hot-column
              :has-tip="true"
              data="userNameCn"
              title="中文名称"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="roleList"
              title="角色名称"
              width="150"
            >
            </hot-column>
            <hot-column
              :has-tip="true"
              data="regionList"
              title="所属区域"
              width="150"
            ></hot-column>
            <!-- <hot-column :has-tip="true" data="age" title="年龄" width="150">
            </hot-column> -->
            <hot-column
              :has-tip="true"
              data="defaultOfficeName"
              title="所属公司"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="dataAuthorityName"
              title="数据权限"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="isExternal"
              title="用户属性"
              dictName="MD_CODE_DICT$EB_USER_EXTERNAL"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="custName"
              title="客户名称"
              width="150"
            ></hot-column>
            <hot-column
              :has-tip="true"
              data="isActive"
              title="有效"
              dictName="MD_CODE_DICT$MD_CODE_YESNO"
              width="150"></hot-column>
            <hot-column :has-tip="true" data="activeStartTime" date-format="YYYY-MM-DD HH:mm:ss" title="生效时间"
                        width="150"></hot-column>
            <hot-column :has-tip="true" data="activeEndTime" date-format="YYYY-MM-DD HH:mm:ss"
                        title="失效时间" width="150">
            </hot-column>
            <hot-column
              :has-tip="true"
              data="userNameEn"
              title="英文名称"
              width="150"
            ></hot-column>
            <hot-column :has-tip="true" data="sex" title="性别" dictName="Sex" width="150"></hot-column>
            <hot-column :has-tip="true" data="mobilePhone" title="手机号" width="150"></hot-column>
            <hot-column :has-tip="true" data="tel" title="办公电话" width="150"></hot-column>
            <hot-column :has-tip="true" data="fax" title="传真" width="150"></hot-column>
            <hot-column :has-tip="true" data="email" title="电子邮箱" width="150"></hot-column>
            <hot-column :has-tip="true" data="qq" title="QQ号" width="150"></hot-column>
            <hot-column :has-tip="true" data="identityCardNo" title="身份证号" width="150"></hot-column>
            <hot-column :has-tip="true" data="companyName" title="间接客户名称" width="150"></hot-column>
            <hot-column :has-tip="true" data="userSource" title="用户来源" dictName="UserSource"
                        width="150"></hot-column>
          </hot-table>
        </el-row>
      </el-col>
      <!-- 分页start -->
      <div class="pg_div">
        <el-pagination
          :current-page="pageConfig.currentPage"
          :layout="pageConfig.layout"
          :page-size="pageConfig.pageSize"
          :page-sizes="pageConfig.pageSizes"
          :total="pageConfig.total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </div>
      <!-- 分页end -->
    </el-form>
  </div>
</template>

<script>
import {queryCarrierInfo, queryDictRows,queryVwCsCustInfo} from "@/api/commonService";
import {sysDataAuthority, sysUserQuery, activeSysUser, deletesSysUser} from "@/api/system";

export default {
  name: "staffManagement",
  data() {
    return {
      associate_columns_sysDataAuthority: [
        {
          title: "权限名称",
          field: "dataAuthorityName",
        },
      ],
      associate_columns_csCustCm: [
        {
          title: "中文简称",
          field: 'custAlias'
        },
        {
          title: "中文全称",
          field: 'custNameCn'
        },
        {
          title: "助记码",
          field: 'mnemonicCode'
        }
      ],
      dict: {},
      userManagementForm: {
        isActive: "1",
      },
      // 分页
      pageConfig: {
        layout: "total, sizes, prev, pager, next, jumper",
        total: 0,
        pageSize: 10,
        pagerCount: 10,
        currentPage: 1,
        pageSizes: [10, 20, 50, 100],
      },
      // currentPage 改变时会触发

      // 表格校验
      userManagementRules: {},
      // 表格数据
      userManagementTableDataSource: [],
      // 表格设置
      userManagementTableSettings: {
        height: 360,
        stretchH: "all", // 根据宽度横向扩展，last:只扩展最后一列，none：默认不扩展
        ...this.$systemConfig.tableConfig,
      },
      isValidList: [
        {
          key: "1",
          value: "是",
        },
        {
          key: "0",
          value: "否",
        },
      ],
    };
  },
  async created() {

  },
  async mounted() {
    //初始化数据字典
    let dictCode = [];
    dictCode.push("MD_CODE_DICT$MD_CODE_YESNO");
    dictCode.push("Sex");
    dictCode.push("MD_CODE_DICT$EB_USER_EXTERNAL");
    dictCode.push("UserSource");
    this.dict = await this.$getDataDictionary.getSelectList(dictCode.join(','));
    for (var key in this.dict) {
      let dict = [];
      this.dict[key].forEach((item) => {
        let param = {};
        param.name = item.value;
        param.value = item.key;
        param.count = 0;
        dict.push(param);
      });
      let dicts = {};
      dicts[key] = dict;
      this.$hotTableUtils.registDict(dicts);
    }
    this.userManagementTableSettings.height = document.body.clientHeight - document.getElementById("searchPanel").offsetHeight - 160;
  },
  methods: {
    handleCurrentChange(val) {
      let self = this;
      console.log(`当前页: ${val}`);
      self.pageConfig.currentPage = val;
      self.handleQuery();
    },
    associate_queryMethod_csCustCm({keyword, pageSize, currentPage}) {
     //let userInfo = JSON.parse(localStorage.getItem("userInfo"));
    // var settleOffice=userInfo.settleOfficeId;

      let params = {}
      if (keyword === '') {
        params = {
          isDeleted6: "0",
          custType4: "%CM%"
         // settleOffice7:settleOffice
        }
      } else {
        params = {
          custAlias0: "%" + keyword + "%",
          custNameCn1: "%" + keyword + "%",
          mnemonicCode2: "%" + keyword + "%",
          isDeleted6: "0",
          custType4: "%CM%"
         // settleOffice7:settleOffice
        }
      }

      let data =
        {
          action: "query",
          crudType: "SELECT",
          sorting: ["CTS_ILPVwCsCust.custNameCn"],
          mainModelName: "CTS_ILPVwCsCust",
          tag: "CTS_WEB_es",
          where: "(((((CTS_ILPVwCsCust.custAlias LIKE :custAlias0 OR CTS_ILPVwCsCust.custNameCn LIKE :custNameCn1) ) AND (CTS_ILPVwCsCust.custType LIKE :custType4 OR CTS_ILPVwCsCust.custType LIKE :custType5)) ) AND CTS_ILPVwCsCust.isDeleted = :isDeleted6  AND CTS_ILPVwCsCust.settleOffice= :settleOffice7)",
          currentPage: currentPage,
          pageSize: pageSize,
          returnPage: true,
          returnTotal: false,
          reqArgs: params,
          fields: [
           "CTS_ILPVwCsCust.csCustId",
           "CTS_ILPVwCsCust.custAlias",
           "CTS_ILPVwCsCust.custNameCn",
           "CTS_ILPVwCsCust.custNameEn",
           "CTS_ILPVwCsCust.custType",
           "CTS_ILPVwCsCust.isActive",
           "CTS_ILPVwCsCust.isBlacklist",
           "CTS_ILPVwCsCust.isCustomer",
           "CTS_ILPVwCsCust.isDeleted",
           "CTS_ILPVwCsCust.isOneTimeCustomer",
           "CTS_ILPVwCsCust.isSettlement",
           "CTS_ILPVwCsCust.isSupplier",
           "CTS_ILPVwCsCust.mdmCustCode",
           "CTS_ILPVwCsCust.postCode"
          ],
          enableCascade: true
        }
      return new Promise(resolve => {
        queryVwCsCustInfo(data).then(res => {
          console.log("queryVwCsCustInfo", res)
          resolve({
            records: res.data.data,
            total: res.data.totalRecord
          })
        })
      }).catch(err => {
        console.log(err)
      })
    },
    associate_queryMethod_sysDataAuthority({keyword, pageSize, currentPage}) {
      let self = this;
      let searchColumns = new URLSearchParams();
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": "1","operation": "EQ"}'
      );
      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isDeleted","columnName": "IS_ACTIVE","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append(
        "sortColumns",
        '{"propertyName":"dataAuthorityName","columnName": "DATA_AUTHORITY_NAME","sortDirection": "asc","sortOrder": "1","operation": "EQ"}'
      );
      searchColumns.append("currentPage", currentPage);
      searchColumns.append("pageSize", 10);
      searchColumns.append("queryResultType", "page");
      keyword
        ? searchColumns.append(
          "searchColumns",
          '{"propertyName":"dataAuthorityName","columnName": "DATA_AUTHORITY_NAME","dataType": "S","value": ' +
          keyword +
          ',"operation": "LIKEIC"}'
        )
        : void 0;
      //   var searchColumns = [
      //     {
      //       propertyName: "isActive",
      //       columnName: "IS_ACTIVE",
      //       dataType: "S",
      //       value: "1",
      //       operation: "EQ"
      //     },
      //     {
      //       propertyName: "isDeleted",
      //       columnName: "IS_DELETED",
      //       dataType: "S",
      //       value: "0",
      //       operation: "EQ",
      //     },
      //   ];
      return new Promise((resolve) => {
        sysDataAuthority(searchColumns).then((res) => {
          console.log("res", res);
          resolve({
            records: res.sysDataAuthoritys,
            total: parseInt(res.total),
          });
        });
      }).catch((err) => {
        console.log(err);
      });
    },
    //queryDictRows数据字典
    // queryDictRows() {
    //   let self = this;
    //   queryDictRows("MD_CODE_DICT$MD_CODE_YESNO").then((res) => {
    //     self.dict.MD_CODE_YESNO = res.MD_CODE_DICT$MD_CODE_YESNO;
    //   });
    // },
    // 新增
    usermaintain() {
      this.$router.push({
        path: "/system/usermaintain",
      });
    },
    // 重置密码
    handleResetPwd() {
      let self = this;
      let paramslength = 0;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        return self.$coreMethods.message(
          "warning",
          "请至少选择一条记录进行删除！"
        )
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 0
        })
        if (anser === true) {
          console.log("ssssssssssssssssss")
        } else {
          self.$coreMethods.message("warning", "不能删除生效用户！");
        }
      }
    },
    // 启用
    handleEnable() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", "请至少选择一条记录进行生效！");
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 0
        })
        if (anser === true) {
          let data = {
            active: 1,
            sysUserIds: "",
          };
          params.forEach((item) => {
            console.log(item)
            data.sysUserIds += item.sysUserId + ",";
          });
          activeSysUser(data).then((res) => {
          })
          this.handleQuery()
          self.$coreMethods.message("warning", "已生效")
        } else {
          self.$coreMethods.message("warning", "请选择未生效的记录！")
        }
      }
    },
    handleAdd() {
      let self = this
      self.$router.push(
        {
          name: 'SysUserIn'
        }
      )
    },
    handleDelete() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", "请至少选择一条记录进行删除！");
      }
      let isAllActive = params.find(function (a) {
        return a.isActive === 1
      })
      if (!isAllActive) {
        self.$coreMethods.confirm(
          function () {
            let data = {
              ids: "",
            };
            params.forEach((item) => {
              data.ids += item.sysUserId + ",";
            });
            deletesSysUser(data).then(res => {
              if (res.success) {
                self.handleQuery()
                self.$coreMethods.message("success", "删除成功!")
              }
            })
          },
          function () {
          },
          false,
          "是否确认删除？"
        );
      } else {
        self.$coreMethods.message("warning", "存在未失效的用户，不可删除！")
      }
    },
    // 禁用
    handleDisable() {
      let self = this;
      let params = self.$refs.userManagementTableRef.getSelections();
      if (params.length < 1) {
        self.$coreMethods.message("warning", "请至少选择一条记录进行失效！")
      } else {
        let anser = params.every(function (a) {
          return a.isActive === 1
        })
        if (anser === true) {
          let data = {
            active: 0,
            sysUserIds: "",
          };
          params.forEach((item) => {
            data.sysUserIds += item.sysUserId + ",";
          });
          activeSysUser(data).then((res) => {
          })
          this.handleQuery()
          self.$coreMethods.message("warning", "已失效!")
        } else {
          self.$coreMethods.message("warning", "请选择未失效的记录！")
        }
      }
    },
    // 查询
    handleQuery() {
      let self = this;
      let searchColumns = new URLSearchParams();

      searchColumns.append(
        "searchColumns",
        '{"propertyName":"isDeleted","columnName": "IS_DELETED","dataType": "S","value": "0","operation": "EQ"}'
      );
      searchColumns.append("queryResultType", "list");
      searchColumns.append("sum", false);
      searchColumns.append("currentPage", self.pageConfig.currentPage);
      searchColumns.append("pageSize", self.pageConfig.pageSize);
      for (let key in self.userManagementForm) {
        if (key === 'isActive') {
        if(self.userManagementForm.isActive){
          searchColumns.append(
            "searchColumns",
            '{"propertyName":"isActive","columnName": "IS_ACTIVE","dataType": "S","value": ' +
            self.userManagementForm.isActive +
            ',"operation": "EQ"}'
          );
          continue;
          }
        }
        if (key === 'isExternal' && self.userManagementForm.isExternal !== "") {
          searchColumns.append(
            "searchColumns",
            '{"propertyName":"isExternal","columnName": "IS_EXTERNAL","dataType": "S","value": ' +
            self.userManagementForm.isExternal +
            ',"operation": "EQ"}'
          );
          continue;
        }
        if (key === 'custId' && self.userManagementForm.custId !== "") {
          searchColumns.append(
            "searchColumns",
            '{"propertyName":"custId","columnName": "CUST_ID","dataType": "S","value": ' +
            self.userManagementForm.custId +
            ',"operation": "EQ"}'
          );
          continue;
        }
        if (self.userManagementForm[key]) {
          searchColumns.append(
            "searchColumns",
            '{"propertyName":" ' + key + ' ","columnName": "' + key.replace(/[A-Z]/g, function ($1) {
              return '_' + $1.toLowerCase()
            }).toUpperCase() + '","dataType": "S","value": "' +
            self.userManagementForm[key] +
            '","operation": "LIKEIC"}'
          );
        }

      }
      sysUserQuery(searchColumns).then((res) => {
        if (res.success) {
          self.userManagementTableDataSource = res.sysUsers;
          self.pageConfig.total = res.total;
        }
      });
    },
    // 重置
    handleReset() {
      this.userManagementForm = {
        isActive: "1",
      };
    },
    // pageSize 改变时会触发
    handleSizeChange(val) {
      console.log(`每页 ${val} 条`);
      this.pageConfig.pageSize = val;
    },
    toInternalUserEditing(val) {
      if (val.record.isExternal === 1) {
        this.$router.push({
          name: 'UserEdit',
          params: {
            sysUserId: val.record.sysUserId
          }
        })
      } else {
        this.$router.push({
          name: 'SysUserIn',
          params: {sysUserId: val.record.sysUserId}
        })
      }
    },
  },
};
</script>

<style scoped lang="less">
</style>
